/**
 * Ancho de cada columna de la tabla de pagos, en unidades de la grilla de 12.
 *
 * Viven acá porque el encabezado y las filas son componentes distintos y tienen
 * que usar los mismos valores: cuando estaban declarados en cada uno, alcanzaba
 * con tocar uno para que dejaran de alinear.
 *
 * Suman 12 exactos. Si no sumaran, el `space-between` del contenedor repartiría
 * la diferencia como huecos entre celdas, y al achicarse el ancho disponible
 * —con el zoom del navegador, por ejemplo— el contenido se sale de la tabla.
 */
export const COLUMN_WIDTHS = {
  id: 1.6,
  date: 1.4,
  terminal: 1.3,
  amount: 1.3,
  type: 1.2,
  brand: 1.2,
  bank: 1.4,
  status: 1.8,
  actions: 0.8
} as const;
